/* Genera ruta de seguimiento */

//*componentes-utiles
import React, { useState } from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
//
import GeneraRuta from "../../../componentes/generaRuta/GeneraRuta";

//extras para ejemplo
import GeneraDropzone from "../../../componentes/generaDropZone/GeneraDropzone";
import GeneraDropzoneUnArchivo from "../../../componentes/generaDropZone/GeneraDropzoneUnArchivo";
import GeneraMenu from "../../../componentes/generaMenu/GeneraMenu";


//store
import rutaStore from "../../../stores/ruta.store";
//import archivaRuta from "../../../archivar/archivaRuta/ArchivaRuta"

//*datos
import menuArch from "../../../datos/json/menu.json";
//*clases

//funciones
//*componente
export default function Ejemplo() {
  

    //store
    const { setGeneraRuta, opcRuta} =
    rutaStore((state:any) =>( {
      setGeneraRuta: state.setGeneraRuta,
      opcRuta: state.opcRuta,
    }));  


      //variables
      let menu= menuArch;
  return (
    <div className="container container-Vista" >
      <h1>Ejemplo de generación de Ruta </h1>
      <div>
        <div><Nav.Link onClick={()=>setGeneraRuta("GeneraDropzone")}>GeneraDropzone</Nav.Link></div>
        <div><Nav.Link onClick={()=>setGeneraRuta("GeneraDropzoneUnArchivo")}>GeneraDropzoneUnArchivo</Nav.Link></div>
        <div><Nav.Link onClick={()=>setGeneraRuta("GeneraMenu")}>GeneraMenu</Nav.Link></div>
      </div>
      <div className="container-Componente" >
        Ruta:
        <GeneraRuta />
        <br/>
      </div> 
      <br/>    
      <div >
        {opcRuta==="GeneraDropzone" ? <GeneraDropzone /> : null} 
        {opcRuta==="GeneraDropzoneUnArchivo" ? <GeneraDropzoneUnArchivo posi={0}/> : null} 
        {opcRuta==="GeneraMenu" ? <GeneraMenu menu={menu} tipo={1} msjTipo2={'Encabezado'}/> : null} 
      </div>
      <br/>
    </div>
  );
}
